<div class="row requestType mb-4" *ngIf="cardData.isServiceOrFunerary?.toString()!='true'">
  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepSender.Cards.SenderQualification.Title' | translate}}</h2>
  </div>

  <!--É habilitando? -->
  <div class="col-sm-12 mt-3">
    <div class="form-check mb-2">
      <input class="form-check-input"
             aria-controls="collapseManual"
             type="checkbox"
             [(ngModel)]="cardData.isBeneficiary"
             name="isBeneficiary"
             id="isBeneficiary"
             #isBeneficiary = "ngModel"
             (change)="isBeneficiaryChanged($event.target.checked)"
             [checked]="cardData.isBeneficiary?.toString()=='true'"
             disabled>
      <label class="form-check-label align-items-center " for="isBeneficiary">
        {{'WorkflowCreatePM.PreStage.CardIdentificacao.Habilitando' | translate}}
      </label>
    </div>
  </div>
  <!--É Representante Legal? -->
  <div class="col-sm-12 mt-3">
    <div class="form-check mb-2">
      <input class="form-check-input"
             aria-controls="collapseManual"
             type="checkbox"
             [(ngModel)]="cardData.isLegalRepresentative"
             name="isLegalRepresentative"
             id="isLegalRepresentative"
             #isLegalRepresentative = "ngModel"
             (change)="isLegalRepresentativeChanged($event.target.checked)"
             [checked]="cardData.isLegalRepresentative?.toString()=='true'"
             disabled>
      <label class="form-check-label align-items-center " for="isLegalRepresentative">
        {{'WorkflowCreatePM.PreStage.CardIdentificacao.RepresentanteLegal' | translate}}
      </label>
    </div>
  </div>
</div>
